import { useState, useEffect } from 'react';
import * as Sentry from "@sentry/react";
import { collection, onSnapshot, orderBy, query, where } from 'firebase/firestore';
import { db } from '../firebase';
import { isOfflineError } from '../lib/firestore';
import { IS_MOCK_DEMO } from '../constants';

export function useTags(user) {
  const [normalizedTags, setNormalizedTags] = useState([]);

  useEffect(() => {
    if (IS_MOCK_DEMO || !user?.uid) return undefined;
    const tagsQuery = query(
      collection(db, 'tags'),
      where('ownerUid', '==', user.uid),
      orderBy('createdAt', 'desc')
    );

    return onSnapshot(tagsQuery, (snapshot) => {
      setNormalizedTags(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    }, (error) => {
      console.error('Error fetching tags:', error);
      if (!isOfflineError(error)) {
        Sentry.captureException(error, { tags: { action: 'subscribe_tags' } });
      }
    });
  }, [user?.uid]);

  return normalizedTags;
}
